// extracted by mini-css-extract-plugin
export default {"reccard":"style_reccard_reccard__EeGIJ","title":"style_reccard_title__rF2ZB","image":"style_reccard_image__sP9HU"};